/**
 * Traces Module
 * 
 * Handles LLM trace inspection.
 */

import { api, TraceEntry } from './api';

/**
 * Initialize traces panel.
 */
export function initTraces(): void {
    const refreshBtn = document.getElementById('refresh-traces');
    if (refreshBtn) {
        refreshBtn.addEventListener('click', refreshTraces);
    }

    refreshTraces();
}

/**
 * Refresh traces from API.
 */
export async function refreshTraces(): Promise<void> {
    try {
        const result = await api.getTraces(20);
        renderTraces(result.traces);
    } catch (err) {
        console.error('Failed to fetch traces:', err);
    }
}

// ============================================================================
// Rendering
// ============================================================================

function renderTraces(traces: TraceEntry[]): void {
    const container = document.getElementById('traces-container');
    if (!container) return;

    if (traces.length === 0) {
        container.innerHTML = `
      <div class="trace-card">
        <span class="text-muted">No LLM traces recorded</span>
      </div>
    `;
        return;
    }

    container.innerHTML = traces.map(trace => `
    <div class="trace-card" data-index="${trace.index}">
      <div class="trace-header">
        <span class="trace-provider">${escapeHtml(trace.provider)}</span>
        <span class="trace-time">${formatTime(trace.timestamp)}</span>
        <span class="trace-duration">${trace.duration_ms}ms</span>
      </div>
      <div class="trace-preview">${escapeHtml(truncate(trace.prompt_preview, 200))}</div>
    </div>
  `).join('');

    // Add click handlers for expansion (future feature)
    container.querySelectorAll('.trace-card').forEach(card => {
        card.addEventListener('click', () => {
            const index = (card as HTMLElement).dataset.index;
            if (index) {
                expandTrace(parseInt(index, 10));
            }
        });
    });
}

async function expandTrace(index: number): Promise<void> {
    try {
        const trace = await api.getTrace(index);
        console.log('Full trace:', trace);
        // TODO: Show in modal
    } catch (err) {
        console.error('Failed to fetch trace:', err);
    }
}

// ============================================================================
// Helpers
// ============================================================================

function formatTime(timestamp: string): string {
    try {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', { hour12: false });
    } catch {
        return timestamp;
    }
}

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function truncate(text: string, maxLen: number): string {
    return text.length > maxLen ? text.slice(0, maxLen) + '…' : text;
}
